import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token to every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('plantshop_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 — auto logout
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('plantshop_token');
      localStorage.removeItem('plantshop_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;

// ── Helpers ──
export const formatPrice = (price) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(price);

export const formatDate = (date) =>
  new Date(date).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' });

export const categoryLabels = {
  'indoor-plants': 'Indoor Plants',
  'outdoor-plants': 'Outdoor Plants',
  'succulents': 'Succulents & Cacti',
  'herbs': 'Herbs & Edibles',
  'flowering-plants': 'Flowering Plants',
  'seeds': 'Seeds',
  'pots-planters': 'Pots & Planters',
  'tools': 'Garden Tools',
  'soil-fertilizers': 'Soil & Fertilizers',
  'watering': 'Watering Equipment',
  'grow-lights': 'Grow Lights',
  'accessories': 'Accessories',
};
